import { memo } from 'react';
import { useTheme } from '@mui/material';
import SurveyCompletedIllustrationLight from './surveyCompleted.svg?react';
import SurveyCompletedIllustrationDark from './surveyCompleted_dark.svg?react';

export const SurveyCompletedIllustration = memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    if (theme.palette.type === 'dark')
      return <SurveyCompletedIllustrationDark aria-hidden="true" {...props} />;
    return <SurveyCompletedIllustrationLight aria-hidden="true" {...props} />;
  },
);
